export default __webpack_public_path__ + "static/media/card-image4.6f4f1cb8.png";